<template>
  <div id="app">
    <router-view v-if="refresh" />
  </div>
</template>

<script>
export default {
  name: 'App',
  provide() {
    return {
      refreshPage: () => this.refreshPage()
    }
  },
  data() {
    return {
      refresh: true // 无痕刷新
    }
  },
  watch: {
    '$route': {
      handler() {
        const { query } = this.$route
        if (query && query.theme) {
          console.log(query)
          this.setTheme(`#${query.theme}`)
        }
      },
      immediate: true
    }
  },
  methods: {
    setTheme(color) {
      this.$store.dispatch('settings/changeSetting', {
        key: 'theme',
        value: color
      })
    },
    // 刷新页面
    refreshPage() {
      this.refresh = false
      this.$nextTick(() => {
        this.refresh = true
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/systemEle.scss';
html, body, #app {
  height: 100%;
  font-family: PingFang SC, Lantinghei SC, Microsoft YaHei, HanHei SC, Helvetica Neue, Open Sans, Arial, Hiragino Sans GB, 微软雅黑 , STHeiti, WenQuanYi Micro Hei, SimSun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
input[type="password"]::-ms-reveal {
    display: none;
	}
.is-text-area {
  .el-input__count {
    right: 20px!important;
    bottom: 1px!important;
  }
  .el-textarea__inner {
    padding-bottom: 30px;
  }
}
</style>
